import React, {useState} from 'react';
import {observer} from "mobx-react";
import Spacer from "./Spacer";
import {Card} from "antd";
import {Container, Draggable} from "react-smooth-dnd";
import {pp} from "../utils";

let applyDrag = (arr, dragResult) => {
  const { removedIndex, addedIndex, payload } = dragResult;
  if (removedIndex === null && addedIndex === null) return arr;

  const result = [...arr];
  let itemToAdd = payload;

  if (removedIndex !== null) {
    itemToAdd = result.splice(removedIndex, 1)[0];
  }

  if (addedIndex !== null) {
    result.splice(addedIndex, 0, itemToAdd);
  }

  return result;
};

let Item = observer(({item, itemRender}) => {
  return <Draggable key={item.id}>
    {itemRender(item)}
  </Draggable>
});

let Group = observer(({onDrop, g, gi, itemRender, groupStyle, titleRender}) => {
  let items = g.items;
  let applyDrop = e => {
    const { removedIndex, addedIndex, payload } = e;
    if (addedIndex === null)
      return;

    onDrop(g, payload, addedIndex);
  }
  return <Card bordered={false} size="small" title={titleRender ? titleRender(g) : `${g.title} (${items.length})`}>
    <div className="space-y-2 custom-scrollbar" style={{height: "70vh", overflowY: "auto"}}>
      <Container
        groupName="col"
        onDrop={applyDrop}
        getChildPayload={index => items[index]}
        dragClass="dnd-card-ghost"
        dropClass="dnd-card-ghost-drop"
        dropPlaceholder={{
          animationDuration: 150,
          showOnTop: true,
          className: 'dnd-drop-preview'
        }}
        dropPlaceholderAnimationDuration={200}
        style={groupStyle || {minWidth: "225px", height: "70vh"}}
      >
        {items.map((item, i) => <Item item={item} index={i} key={i} itemRender={itemRender}/>)}
      </Container>
    </div>
  </Card>
})

export default observer(({groups, ...props}) => {
  return <div className="flex space-x-4">
    {groups.map((g, gi) => <Group g={g} key={gi} {...props}/>)}
  </div>
});

